"use client"

import  React from "react"
import { Modal, Button } from "antd"
import { ArrowLeftOutlined, CloseOutlined } from "@ant-design/icons"
import PropTypes from "prop-types" // Import PropTypes

const BillHistoryModal= ({ isOpen, onClose }) => {
  return (
    <Modal
    centered
    maskClosable={false} 
        keyboard={false}
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#1890ff",
            margin: "-20px -24px 20px",
            padding: "10px 24px",
            color: "white",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <ArrowLeftOutlined style={{ marginRight: "10px" }} />
            <span>Bill on 29-04-2025</span>
          </div>
          <div>
            <Button
              type="primary"
              style={{
                marginRight: "10px",
                background: "white",
                color: "#1890ff",
                borderColor: "white",
              }}
            >
              Edit
            </Button>
            <Button
              type="primary"
              style={{
                marginRight: "10px",
                background: "white",
                color: "#1890ff",
                borderColor: "white",
              }}
                >
              Print
            </Button>
            <Button type="text" icon={<CloseOutlined />} onClick={onClose} style={{ color: "white" }} />
          </div>
        </div>
      }
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={600}
      styles={{ padding: "0 24px 24px" }}
      closable={false}
    >
      <div style={{ marginBottom: "20px" }}>
        <div style={{ color: "#666" }}>Bill No.: SRH/2025-2026/1000005</div>
        <h3>Itemized Bill</h3>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <div>Consultation</div>
        <div
          style={{
            background: "#f5f5f5",
            padding: "8px 16px",
            borderRadius: "4px",
            width: "200px",
            textAlign: "right",
          }}
        >
          600
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div>x-ray</div>
        <div
          style={{
            background: "#f5f5f5",
            padding: "8px 16px",
            borderRadius: "4px",
            width: "200px",
            textAlign: "right",
          }}
        >
          200
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "30px",
        }}
      >
        <div></div>
        <div style={{ fontWeight: "bold" }}>Total ₹800</div>
      </div>

      <h3>Payment</h3>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            background: "#f5f5f5",
            padding: "8px 16px",
            borderRadius: "4px",
            width: "200px",
          }}
        >
          Cash
        </div>
        <div
          style={{
            background: "#f5f5f5",
            padding: "8px 16px",
            borderRadius: "4px",
            width: "200px",
            textAlign: "right",
          }}
        >
          600
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <div style={{ color: "#666" }}>Receipt Number: A1241</div>
        <div style={{ fontWeight: "bold" }}>Total ₹600</div>
      </div>
    </Modal>
  )
}

BillHistoryModal.propTypes = {
    isOpen: PropTypes.bool.isRequired, // isOpen must be a boolean and is required
    onClose: PropTypes.func.isRequired, // onClose must be a function and is required
  }

export default BillHistoryModal
